import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timeline-item-content info-card log-in-out-event"
}
const _hoisted_2 = {
  key: 1,
  class: "timeline-item-content info-card"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 2,
  class: "timeline-item-content info-card"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", null, "URL: ", -1)
const _hoisted_8 = {
  key: 3,
  class: "timeline-item-content info-card"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", null, "Assignment Status: ", -1)
const _hoisted_12 = {
  key: 4,
  class: "timeline-item-content info-card lesson-complete-event"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 5,
  class: "timeline-item-content info-card"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "timeline-item-content info-card"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 2 }

import TimelineEvent from "@/components/TimelineEvent.vue";
import {
  AuditLogEvent,
  AuditLogEventActor,
  AuditLogEventType,
  AuditLogReferenceType,
} from "@/services/auditLogService";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineAuditLogEvent',
  props: {
    event: {}
  },
  setup(__props: any) {



const actorClassNames: Record<AuditLogEventActor, string> = {
  [AuditLogEventActor.Cohort]: "course-event",
  [AuditLogEventActor.User]: "student-action",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TimelineEvent, {
    timestamp: _ctx.event.timestamp,
    class: _normalizeClass(actorClassNames[_ctx.event.actor])
  }, {
    default: _withCtx(() => [
      (_ctx.event.actor === _unref(AuditLogEventActor).User)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.event.type === _unref(AuditLogEventType).UserLoggedIn || _ctx.event.type === _unref(AuditLogEventType).UserLoggedOut)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("p", null, [
                    _createElementVNode("b", null, [
                      _createElementVNode("i", null, _toDisplayString(_ctx.event.title), 1)
                    ])
                  ])
                ]))
              : (_ctx.event.type === _unref(AuditLogEventType).Redirected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("p", null, [
                      _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                      (_ctx.event.note)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.event.note), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_ctx.event.type === _unref(AuditLogEventType).PageViewed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.references, (reference) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: reference.content
                        }, [
                          (reference.type === _unref(AuditLogReferenceType).Assignment)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                                _createElementVNode("b", null, _toDisplayString(reference.content), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (reference.type === _unref(AuditLogReferenceType).Url)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("code", null, _toDisplayString(reference.content), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]))
                  : (_ctx.event.type === _unref(AuditLogEventType).UserActionItem)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_ctx.event.note)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                              _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                              _createElementVNode("b", null, _toDisplayString(_ctx.event.note), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.references, (reference) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: reference.content
                          }, [
                            (reference.type === _unref(AuditLogReferenceType).Status)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("b", null, _toDisplayString(reference.content), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]))
                    : (_ctx.event.type === _unref(AuditLogEventType).LessonCompleted)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.references, (reference) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: reference.content
                            }, [
                              (reference.type === _unref(AuditLogReferenceType).Assignment)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                    _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                                    _createElementVNode("b", null, _toDisplayString(reference.content), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (reference.type === _unref(AuditLogReferenceType).Status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(reference.content), 1))
                                : _createCommentVNode("", true),
                              (reference.type === _unref(AuditLogReferenceType).Url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("code", null, _toDisplayString(reference.content), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (_ctx.event.note)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.event.note), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.references, (reference) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: reference.content
                            }, [
                              (reference.type === _unref(AuditLogReferenceType).Assignment)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                    _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                                    _createElementVNode("b", null, _toDisplayString(reference.content), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (reference.type === _unref(AuditLogReferenceType).Status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(reference.content), 1))
                                : _createCommentVNode("", true),
                              (reference.type === _unref(AuditLogReferenceType).Url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("code", null, _toDisplayString(reference.content), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (_ctx.event.note)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.event.note), 1))
                            : _createCommentVNode("", true)
                        ]))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.event.actor === _unref(AuditLogEventActor).Cohort)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_ctx.event.type === _unref(AuditLogEventType).CohortLaunch || _ctx.event.type === _unref(AuditLogEventType).CohortEnd)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                  _createElementVNode("b", null, [
                    _createElementVNode("i", null, _toDisplayString(_ctx.event.title), 1)
                  ])
                ]))
              : (_ctx.event.type === _unref(AuditLogEventType).Milestone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                    _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                    (_ctx.event.note)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_25, _toDisplayString(_ctx.event.note), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_26, [
                    _createElementVNode("i", null, _toDisplayString(_ctx.event.title) + ": ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.references, (reference) => {
                      return (_openBlock(), _createElementBlock("b", {
                        key: reference.content
                      }, _toDisplayString(reference.content), 1))
                    }), 128))
                  ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["timestamp", "class"]))
}
}

})